import { PowerWord } from "./PowerWord";

export * from "./PowerWord";

export default PowerWord;
